"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("react");
var useClient_1 = require("../../../../../hooks/useClient");
// function EmailCellView({ cellValue }: IProps) {
//   if (!cellValue) {
//     return <div>-</div>;
//   }
//   return <div className="text-nowrap text-sm text-default-foreground">{cellValue.toLowerCase()}</div>;
// }
// export function PriceCellView({ cellValue, client }: IProps) {
//   return (
//     <div className="text-nowrap text-sm capitalize text-default-foreground">
//       {!!cellValue
//         ? formatMoney({
//             symbol: client?.currency_symbol,
//             value: cellValue?.toString() ?? "0",
//             symbolSeparation: true,
//           })
//         : "R 0.00"}
//     </div>
//   );
// }
function StatusCellView(_a) {
    var status = _a.status;
    var color = (0, react_2.useMemo)(function () {
        if (["released"].includes(status)) {
            return "success";
        }
        else {
            return "default";
        }
    }, [status]);
    return ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap text-xs capitalize", color: color, size: "sm", variant: "soft", children: status }));
}
var ScheduleCellView = function (_a) {
    var schedule = _a.schedule;
    var formattedSchedule = (0, react_2.useMemo)(function () {
        if (!(schedule === null || schedule === void 0 ? void 0 : schedule.start_date) || !(schedule === null || schedule === void 0 ? void 0 : schedule.end_date))
            return "";
        var startDate = (0, utils_1.formatDateTime)(new Date(schedule.start_date));
        var endDate = (0, utils_1.formatDateTime)(new Date(schedule.end_date));
        return "".concat(startDate, " - ").concat(endDate);
    }, [schedule]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: formattedSchedule }));
};
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_2.useCallback)(function (cellValue) {
        return [
            { key: "title", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            {
                key: "schedule",
                content: (0, jsx_runtime_1.jsx)(ScheduleCellView, { schedule: cellValue }),
            },
            { key: "status", content: (0, jsx_runtime_1.jsx)(StatusCellView, { status: cellValue }) },
        ];
    }, [client]);
    return (0, react_2.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
